<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
  <div>
    <br />
    <div class='titleContainer'>
      <h2 class='header'>Part Categories</h2>
    </div>
    <br />

    <div class="row content-block">
      <div class="col">
        <table class='table table-bordered table-hover' >
          <thead class='thead-light'>
            <tr>
              <th>Category</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            @for (cat of this.categories; track cat) {
              <tr>
                <td colspan='2'>
                  {{cat.name}}
                </td>
              </tr>
            }
            @if (!this.disableButtons) {
              <tr>
                <td colspan='2'>
                  <button class='btn btn-secondary' (click)='addNewRow()'><i class="fas fa-plus"></i> New</button>
                </td>
              </tr>
            }
            @if (this.disableButtons) {
              <tr>
                <td>
                  <label>Category Name</label>
                  <input type='text' [(ngModel)]='this.newItem.name' class='form-control'/>
                </td>
                <td><button class='btn btn-success' (click)='save()'>Save</button></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
